import { render, staticRenderFns } from "./SimulationCompetencies.vue?vue&type=template&id=770fcad4&scoped=true"
import script from "./SimulationCompetencies.vue?vue&type=script&lang=js"
export * from "./SimulationCompetencies.vue?vue&type=script&lang=js"
import style0 from "./SimulationCompetencies.vue?vue&type=style&index=0&id=770fcad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770fcad4",
  null
  
)

export default component.exports